import layoutHeaderAside from '@/layout/header-aside'
import bus from '@/components/view-bus'
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 信鸽路由
export default [
  {
    path: '/prepay',
    name: 'PrePay',
    meta: {
      title: '财务',
      auth: true
    },
    // component: _import('payfee/prepay')
    // redirect: { name: 'PrePayIndex' },
    component: layoutHeaderAside,
    children: [
      // {
      //   path: 'index',
      //   name: 'PrePayIndex',
      //   meta: {
      //     title: '预定管理',
      //     auth: true
      //   },
      //   component: _import('payfee/prepay')
      // },
      {
        path: 'prepayOnlineSetting',
        name: 'prepayOnlineSetting',
        meta: {
          title: '网络报名设置',
          auth: true
        },
        component: _import('payfee/advance/online-set')
      },
      {
        path: 'prepayOnline',
        name: 'prepayOnline',
        meta: {
          title: '网络报名订单',
          auth: true
        },
        component: _import('payfee/advance/online-list')
      },

      {
        path: 'payAdvanceInfo',
        name: 'PayAdvanceInfo',
        meta: {
          title: '预定支付详情',
          auth: true
        },
        component: _import('payfee/advance/order-info')
      },
      {
        path: 'taleAdvance',
        name: 'TaleAdvance',
        meta: {
          title: '预定订单',
          auth: true
        },
        component: _import('payfee/advance/taleorder')
      },
      // {
      //   path: 'payAdvancePayLog',
      //   name: 'PayAdvancePayLog',
      //   meta: {
      //     title: '预定支付记录',
      //     auth: true
      //   },
      //   component: _import('payfee/advance/pay-log')
      // },

      // {
      //   path: 'payAdvance',
      //   name: 'PayAdvance',
      //   meta: {
      //     title: '预定订单管理',
      //     auth: true
      //   },
      //   component: _import('payfee/advance/order-list')
      // },
      {
        path: 'taleAssign',
        name: 'TaleAssign',
        meta: {
          title: '技能赛订单',
          auth: true
        },
        component: _import('payfee/assign/taleorder')
      },
      // {
      //   path: 'payAssign',
      //   name: 'PayAssign',
      //   meta: {
      //     title: '技能赛订单管理',
      //     auth: true
      //   },
      //   component: _import('payfee/assign/order-list')
      // },
      // {
      //   path: 'payAssignOrderInfo',
      //   name: 'PayAssignOrderInfo',
      //   meta: {
      //     title: '订单详情',
      //     auth: true
      //   },
      //   component: _import('payfee/assign/order-info')
      // },
      // {
      //   path: 'payAssignPayLog',
      //   name: 'PayAssignPayLog',
      //   meta: {
      //     title: '支付记录',
      //     auth: true
      //   },
      //   component: _import('payfee/assign/pay-log')
      // },
      // {
      //   path: 'backAssignLog',
      //   name: 'backAssignLog',
      //   meta: {
      //     title: '退款记录',
      //     auth: true
      //   },
      //   component: _import('payfee/assign/back-log')
      // },
      {
        path: 'payAward',
        name: 'payAward',
        meta: {
          title: '奖金赛订单',
          auth: true
        },
        component: _import('payfee/award/taleorder')
      },
      {
        path: 'BonusUmmary',
        name: 'BonusUmmary',
        meta: {
          title: '奖金汇总',
          auth: true
        },
        component: _import('payfee/award/bonusummary')
      },
      {
        path: 'payAwardOrderInfo',
        name: 'PayAwardOrderInfo',
        meta: {
          title: '订单详情',
          auth: true
        },
        component: _import('payfee/award/order-info')
      },
      // {
      //   path: 'payAwardPayLog',
      //   name: 'PayAwardPayLog',
      //   meta: {
      //     title: '支付记录',
      //     auth: true
      //   },
      //   component: _import('payfee/award/pay-log')
      // },
      // {
      //   path: 'backAwardLog',
      //   name: 'backAwardLog',
      //   meta: {
      //     title: '退款记录',
      //     auth: true
      //   },
      //   component: _import('payfee/award/back-log')
      // },
      {
        path: 'payments',
        name: 'Payments',
        meta: {
          title: '拍鸽收支表',
          auth: true
        },
        component: _import('payfee/payments')
      },
      {
        path: 'taletrade',
        name: 'Taletrade',
        meta: {
          title: '拍卖订单',
          auth: true
        },
        component: _import('payfee/taletrade')
      },
      // {
      //   path: 'trade',
      //   name: 'Trade',
      //   meta: {
      //     title: '拍卖交易管理',
      //     auth: true
      //   },
      //   component: _import('payfee/trade')
      // },
      // {
      //   path: 'payLog',
      //   name: 'PayLog',
      //   meta: {
      //     title: '拍主支付记录',
      //     auth: true
      //   },
      //   component: _import('payfee/pay-log')
      // },
      // {
      //   path: 'paymentLog',
      //   name: 'PaymentLog',
      //   meta: {
      //     title: '鸽主结款记录',
      //     auth: true
      //   },
      //   component: _import('payfee/payment-log')
      // },
      {
        path: 'tradeInfo',
        name: 'TradeInfo',
        meta: {
          title: '交易详情',
          auth: true
        },
        component: _import('payfee/trade-info')
      },
      {
        path: 'payMoney',
        name: 'payMoney',
        meta: {
          title: '付款/结款',
          auth: true
        },
        component: _import('payfee/pay-money')
      },
      {
        path: 'retpay',
        name: 'RetPay',
        meta: {
          title: '退费管理',
          auth: true
        },
        component: _import('payfee/retpay')
      },
      {
        path: 'MatchPay',
        name: 'MatchPay',
        meta: {
          title: '赛事交费',
          auth: true
        },
        redirect: { name: 'MatchPayIndex' },
        component: bus,
        children: [
          {
            path: 'index',
            name: 'MatchPayIndex',
            meta: {
              title: '赛事交费',
              auth: true
            },
            component: _import('payfee/MatchPay/index')
          },
          {
            path: 'printMark',
            name: 'PrintMark',
            meta: {
              title: '打印笼号',
              auth: true
            },
            component: _import('payfee/MatchPay/printCageNo')
          },
          {
            path: 'printCilp',
            name: 'PrintCilp',
            meta: {
              title: '打印参赛卡',
              auth: true
            },
            component: _import('payfee/MatchPay/new-card-1')
          },
          {
            path: 'PigeonPay',
            name: 'PigeonPay',
            meta: {
              title: '信鸽交费',
              auth: true
            },
            component: _import('payfee/MatchPay/PigeonPay')
          },
          {
            path: 'RoomPay',
            name: 'RoomPay',
            meta: {
              title: '后台交费',
              auth: true
            },
            component: _import('payfee/MatchPay/RoomPay')
          },
          {
            path: 'HostPay',
            name: 'HostPay',
            meta: {
              title: '鸽主交费',
              auth: true
            },
            component: _import('payfee/MatchPay/HostPay/index')
          },
          {
            path: 'paying',
            name: 'Paying',
            meta: {
              title: '鸽主交费',
              auth: true
            },
            component: _import('payfee/MatchPay/HostPay/paying')
          },
          {
            path: 'payfee/MatchPay/HostPay/PayDetail',
            name: 'PayDetail',
            meta: {
              title: '交费详情',
              auth: true
            },
            component: _import('payfee/MatchPay/HostPay/PayDetail')
          }
        ]
      },

      {
        path: 'order',
        name: 'order',
        meta: {
          title: '订单管理',
          auth: true
        },
        redirect: { name: 'orderIndex' },
        component: bus,
        children: [
          {
            path: 'index',
            name: 'orderIndex',
            meta: {
              title: '订单管理',
              auth: true
            },
            component: _import('payfee/order/index')
          },
          {
            path: 'OrderDetail',
            name: 'OrderDetail',
            meta: {
              title: '订单详情',
              auth: true
            },
            component: _import('payfee/order/OrderDetail')
          }
        ]
      },
      {
        path: 'agencyFee',
        name: 'agencyFee',
        meta: {
          title: '代理费管理',
          auth: true
        },
        redirect: { name: 'agencyFeeList' },
        component: bus,
        children: [
          {
            path: 'agencyFeeList',
            name: 'agencyFeeList',
            meta: {
              title: '代理费管理',
              auth: true,
              cache: true
            },
            component: _import('payfee/agency-fee/agency-fee-list')
          },
          {
            path: 'agencycollect',
            name: 'agencycollect',
            meta: {
              title: '收鸽',
              auth: true
            },
            component: _import('payfee/agency-fee/collect-pigeon')
          },
          {
            path: 'orderlist',
            name: 'orderlist',
            meta: {
              title: '订单',
              auth: true
            },
            component: _import('payfee/agency-fee/order-list')
          },
          {
            path: 'paylist',
            name: 'paylist',
            meta: {
              title: '已付款',
              auth: true
            },
            component: _import('payfee/agency-fee/pay-list')
          },
          {
            path: 'unpaylist',
            name: 'unpaylist',
            meta: {
              title: '未付款',
              auth: true
            },
            component: _import('payfee/agency-fee/unpay-list')
          },
          {
            path: 'takepart',
            name: 'takepart',
            meta: {
              title: '参赛',
              auth: true
            },
            component: _import('payfee/agency-fee/take-part')
          }
        ]
      },
      {
        path: 'statis',
        name: 'statis',
        meta: {
          title: '现场交费统计',
          auth: true
        },
        redirect: { name: 'statisIndex' },
        component: bus,
        children: [
          {
            path: 'index',
            name: 'statisIndex',
            meta: {
              title: '现场交费统计',
              auth: true
            },
            component: _import('payfee/statistics/index')
          }
        ]
      }
    ]
  }
]
